import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionStatisticsDirectRRPPByEvent } from "../../actions/EventActions"
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import SearchIcon from '@material-ui/icons/Search';
import ViewDetail from '@material-ui/icons/Visibility';
import Util, { ERROR } from '../../common/Util'
import BackIcon from '@material-ui/icons/ArrowBackRounded';

class StatisticsDirectRRPP extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:5, count:0, rrpps:[], filter:"", showPop:false, detailList:[]}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.onSearch=this.onSearch.bind(this)
  }
  
  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    console.log("PROPS", this.props)
    this.props.actionStatisticsDirectRRPPByEvent(this.props.event.id
                                        , this.onChangePage
                                        , (e)=>{console.log("ERROR",e); Util.showNoty(ERROR, "Ocurrió un error al listar las ventas")})
  }

  onChangePage(evt=null, newPage=0){
    const from=newPage*this.state.rowPerPage
    const end=from+this.state.rowPerPage
    const filter = new RegExp(this.state.filter,"ig")
    let rrpps = this.props.directRrppList.filter((r)=>{return `${r.lastname}, ${r.name}`.match(filter)})
    const count = rrpps.length
    rrpps = rrpps.slice(from, end)
    this.setState({page:newPage, count:count, rrpps:rrpps})
  }

  onChangeRowsPerPage(evt){
    const from=this.state.page*evt.target.value
    const end=from+evt.target.value
    const filter = new RegExp(this.state.filter,"ig")
    let rrpps = this.props.directRrppList.filter((r)=>{return `${r.lastname}, ${r.name}`.match(filter)})
    const count = rrpps.length
    rrpps = rrpps.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, rrpps:rrpps})
  }

  onSearch(evt){
   this.setState({filter:evt.target.value},this.onChangePage)
  }



  renderTableHeader(){
    // const {theme} = this.props
    const headers = ["RRPP","Cantidad", "Importe", "Ver detalle"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      {/* <TableCell style={theme.table.actionsColumn}>Acciones</TableCell> */}
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let rrpps = this.state.rrpps
    if(!rrpps||rrpps.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return rrpps.map((item, index)=>{
      // console.log(index, item)
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{item.name} {item.lastname}</TableCell>
          <TableCell>
            {Util.formatNumber(item.totalQt)}
          </TableCell>
          <TableCell>
            {Util.formatCurrency(item.totalAmount)}
          </TableCell>
          <TableCell>
              <IconButton onClick={()=>{this.setState({showPop:true, rrpp:item, detailList:item.detailByType})}}>
                <ViewDetail/>
              </IconButton>
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, event} = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Ventas Directas por RRPP</Typography>
            <Typography variant="subtitle1">Evento {event.evtName}</Typography>
          </Box>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">{event.evtName}</Typography>
            <Toolbar style={{...theme.table.toolbar, justifyContent:"flex-end"}}>
              <Box> 
                <Input placeholder="Buscar" onChange={this.onSearch}/>
              </Box>
            </Toolbar>
              <Table stickyHeader>
                <TableHead > 
                  {this.renderTableHeader()}
                </TableHead>
                <TableBody>
                  {this.renderTableBody()}
                </TableBody>
              </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.showPop}>
            <DialogTitle>{this.state.rrpp&&this.state.rrpp.name} {this.state.rrpp&&this.state.rrpp.lastname}</DialogTitle>
            <DialogContent>
              <DialogContentText>{"Venta directa"}</DialogContentText>
              <Table stickyHeader style={{minWidth:500, boxShadow:"0 2px 4px 0 rgba(0, 0, 0, 0.23)"}}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{backgroundColor:"#f6f6f6"}}>Ticket</TableCell>
                    <TableCell style={{backgroundColor:"#f6f6f6"}} align="right" >Importe</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.detailList.map((d, index)=>{
                    return (
                      <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
                        <TableCell>{`${d.totalQt} - ${d.tktProducerName}`}</TableCell>
                        <TableCell align="right">{Util.formatCurrency(d.totalAmount)}</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" color="primary" onClick={()=>this.setState({showPop:false})}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    event: store.evt.eventStats,
    directRrppList: store.evt.directRrppList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionStatisticsDirectRRPPByEvent
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(StatisticsDirectRRPP)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/events/StatisticsDirectRRPP.js